export interface FieldConfiguration {
  destKey?: string;
  destLabel?: string;
  sourseKey?: string;
  sourceKey?: string;
  sourseLabel?: string;
  sourceLabel?: string;
  defaultValue?: unknown;
  isFromPreference?: boolean;
}

export interface Attribute {
  preference?: FieldConfiguration | FieldConfiguration[];
  default?: FieldConfiguration;
}

export const getFieldConfig = (attr: Attribute): FieldConfiguration => {
  if (attr.preference) {
    if (Array.isArray(attr.preference) && attr.preference.length > 0) {
      return { ...attr.preference[0], isFromPreference: true };
    }
    if (
      typeof attr.preference === 'object' &&
      !Array.isArray(attr.preference) &&
      Object.keys(attr.preference).length > 0
    ) {
      return { ...attr.preference, isFromPreference: true };
    }
  }
  return { ...attr.default, isFromPreference: false };
};

export const getDisplayLabel = (attr: Attribute): string => {
  const config = getFieldConfig(attr);
  return config.destLabel || config.sourseLabel || '';
};

export const getFieldKey = (attr: Attribute): string => {
  const config = getFieldConfig(attr);
  return config.destKey || '';
};

export const getSourceKey = (attr: Attribute): string => {
  const config = getFieldConfig(attr);
  return config.sourseKey || config.sourceKey || '';
};

export const getSourceLabel = (attr: Attribute): string => {
  const config = getFieldConfig(attr);
  return config.sourseLabel || config.sourceLabel || '';
};
